import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">关于51吃瓜在线</h2>
          <p className="text-sm text-foreground-600 mt-3">了解国内领先的娱乐资讯聚合平台</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="flex flex-col lg:flex-row gap-10 items-center">
              <div className="flex-1">
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  {aboutInfo.description1}
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {aboutInfo.description2}
                </p>
              </div>
              <div className="flex-shrink-0">
                <div className="grid grid-cols-2 gap-4">
                  {aboutInfo.stats.map((stat, i) => (
                    <div
                      key={i}
                      className="bg-background-50 rounded-xl px-6 py-5 text-center border border-background-200/70 min-w-[120px]"
                    >
                      <div className="text-xl md:text-2xl font-bold text-accent-500">{stat.value}</div>
                      <div className="text-xs text-foreground-600 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}